import { Component } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { ButtonComponent } from '../../../components/button/button.component';
import { TableService } from '../../../domain/services/table.service';

@Component({
    selector: 'app-pay-tax',
    imports: [
        ButtonComponent,
    ],
    templateUrl: './pay-tax.component.html',
    styleUrl: './pay-tax.component.scss'
})
export class PayTaxComponent {
  constructor(
    private ngxSmartModalService: NgxSmartModalService, 
    private tableService: TableService,
  ) {}

  activateTax() {
    this.tableService.setRemoveTax(false);
    this.ngxSmartModalService.getModal('pay-tax-modal').close()
  }
  
  deactivateTax() {
    this.ngxSmartModalService.setModalData({ remove: true }, 'pay-tax-modal')
    this.ngxSmartModalService.getModal('pay-tax-modal').close()
  }
}
